import styled from 'styled-components';

export default styled.h4`
  line-height: 2rem;
  margin: 0;
  font-family: sans-serif;
`;
